import type {
  EmployeeEarningKind,
  PayrollAdjustmentKind,
} from '@aeris/contracts'

/**
 * As palavras da folha, num lugar só — F157.
 *
 * O cadastro, a folha do mês e o diálogo de lançamento leem daqui. Uma segunda
 * cópia escrita à mão seria a primeira a envelhecer, e o efeito de envelhecer
 * aqui é a mesma linha aparecer como "Bônus" numa tela e "Bonificação" na
 * outra, como se fossem duas coisas.
 */

/** A ordem é a que a pessoa lê na folha: o salário primeiro, o resto depois. */
export const EARNING_KINDS = [
  'salary',
  'bonus',
  'transport',
  'meal',
] as const satisfies readonly EmployeeEarningKind[]

export const EARNING_LABELS: Record<EmployeeEarningKind, string> = {
  salary: 'Salário',
  bonus: 'Bônus fixo',
  transport: 'Vale-transporte',
  meal: 'Vale-alimentação',
}

/**
 * O que cada um é, dito para quem está cadastrando.
 *
 * "Bônus fixo" precisa da frase mais do que os outros: é justamente a
 * diferença entre ele e o bônus pontual que a tela tem de ensinar.
 */
export const EARNING_HINTS: Record<EmployeeEarningKind, string> = {
  salary: 'O combinado por mês.',
  bonus: 'Todo mês, junto com o salário. Para o de uma vez só, lance na folha.',
  transport: 'Se você paga junto com o salário.',
  meal: 'Se você paga junto com o salário.',
}

export const ADJUSTMENT_LABELS: Record<PayrollAdjustmentKind, string> = {
  bonus: 'Bônus',
  discount: 'Desconto',
}
